<template>
  <div>
    <!-- password reset card -->
    <v-card rounded="0" :loading="loading">
      <div class="px-5 py-10">
        <!-- password reset form -->
        <v-form ref="form" @submit.prevent="reset" v-model="valid">
          <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({name: 'Login'})"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-card-title class="primary--text">Reset password</v-card-title>
          </div>

          <v-card-text>
            <!-- email textfield -->
            <v-text-field
              v-model="email"
              autofocus
              label="Email"
              :disabled="loading"
              :rules="[rules.required, rules.email]"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <!-- password reset button -->
            <v-btn
              large
              rounded
              block
              color="primary"
              type="submit"
              :disabled="loading"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>

    <!-- error/success dialog -->
    <base-alert-dialog
      v-model="dialog.show"
      :message="dialog.message"
      @confirm="dialog.error ? dialog.show = false : $router.push({name: 'Login'})"
    ></base-alert-dialog>
  </div>
</template>

<script>
  export default {
    name: 'ResetPassword',

    data: () => ({
      dialog: {
        show: false,
        message: '',
        error: false
      },
      email: '',
      valid: false,
      loading: false,
      rules: {
        required: (v) => !!v || "This field is required",
        email: (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      }
    }),

    computed: {
      //
    },

    methods: {
			async reset() {
				await this.$refs.form.validate();

				if (this.valid) {
					try {
            this.loading = true;
            var response = await this.$store.dispatch("password/reset", {email: this.email});
            console.log('[reset/response]', response)
            this.loading = false;
            if (response.status == 200) {
              // show success popup
              this.dialog.error = false
              this.dialog.show = true
              this.dialog.message = "Password reset link has been sent to your email."
            }
          }
          catch(e) {
            console.log('[error]', e)
            this.loading = false;
            // show error popup
            this.dialog.error = true
            this.dialog.show = true
            this.dialog.message = "Sorry, your request cannot be processed. Please try again."
          }
				}
			},
		}
  }
</script>

<style lang="scss" scoped>

</style>